import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
	selector: 'app-modal-edit',
	templateUrl: './modal-edit.component.html',
	styleUrls: ['./modal-edit.component.scss']
})
export class ModalEditComponent implements OnInit {

	@Input()
	public header: string;
	@Input()
	disabledExcluir = false;
	@Output()
	save = new EventEmitter<Promise<any>>();
	@Input()
	disableSalvar = false;
	@Input()
	showSave = true;
	@Output()
	delete = new EventEmitter<Promise<any>>();
	@Output()
	close = new EventEmitter<void>();

	ngOnInit(): void {
		if (this.delete.observers.length === 0) {
			this.delete = null;
		}
	}

}
